import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import Collapse from '@material-ui/core/Collapse'

import formatPrice from '../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../utilities/currency/getCurrencySymbol'

import renderHTML from 'react-render-html'
import moment from 'moment/moment'
import yn from 'yn'
import _ from 'lodash'

import placeholderImage from '../../assets/images/placeholder-image.png'

if (yn(process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES) ) {
	require('../../styles/css/components/room/bk-flow-special-packages.css')
}

const CollapseWrapper = ({ children, isExpanded }) => (
	<Collapse
		in={ isExpanded }
		timeout={ 300 }
	>
		{children}
	</Collapse>
)

const ModalWrapper = ({
	children,
	isExpanded,
	onRequestClose,
	parentElementId,
}) => (
	<Modal
		parentSelector={() => document.getElementById(parentElementId)}
		className={{
			base: 'u-modal u-modal--xs',
			afterOpen: 'u-modal--visible',
			beforeClose: 'u-modal--close',
			ariaHideApp: false
		}}
		overlayClassName={{
			base: 'u-fade',
			afterOpen: 'u-fade--visible',
			beforeClose: 'u-fade--visible'
		}}
		isOpen={isExpanded}
		onRequestClose={onRequestClose}
		shouldCloseOnEsc
		// contentLabel="Confirmation Policies Modal"
		shouldCloseOnOverlayClick
		ariaHideApp={false}
	>
		{children}
	</Modal>
)

class BkFlowRoomSpecialPackages extends Component {
	constructor(props) {
		super(props)

		this.state = {
			specialPackagesExpanded: this.props.specialPackagesExpanded
		}
	}

	// Construct details accordion
	renderSpecialPackagesAccordion() {
		const {
			configData,
			urlData,
			multiRoomData,
			availabilityData,
			activeCurrencyData,
			enhancementData,
			activeStep,
			roomGroup,
			roomData,
			roomTypeCode,
			specialPackagesExpanded,
			toggleActiveRoom,
			toggleSpecialPackages,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		const totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')

		let baseClassNames = 'sp-row'

		if (process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES_LAYOUT === 'column') {
			baseClassNames = 'sp-column'
		}

		// Init room offers rates data
		let activeHotelCode = null
		let matchedProperty = null
		let displayedPriceFrequency = 'per stay'
		let availRatePlans = null
		let availRoomRates = null

		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(activeHotelCode)
			})
		}

		if (matchedProperty && matchedProperty.displayPricesTimeline) {
			displayedPriceFrequency = matchedProperty.displayPricesTimeline
		}

		// set room offers rates data
		if (
			roomData.viewExtensions &&
			roomData.viewExtensions.roomRates
		) {
			availRoomRates = roomData.viewExtensions.roomRates
		}

		if (
			availabilityData[roomGroup]
			&& availabilityData[roomGroup][0]
			&& availabilityData[roomGroup][0].ratePlans
		) {
			availRatePlans = availabilityData[roomGroup][0].ratePlans
		}

		// setting specialRates from synxis
		let specialPackageRates = null

		// setting specialRates from synxis
		if (
			roomData.viewExtensions &&
			!_.isEmpty(roomData.viewExtensions.specialPackageRates)
	) {
			specialPackageRates = roomData.viewExtensions.specialPackageRates
		}

		function renderSpecialPackageCards() {
			const specialPackageEntries = []

			// Loop applicable rates
			specialPackageRates.forEach(rateKey => {

				// Match applicable rate codes by room type and room rates
				availRoomRates.forEach(rate => {
					if (
						rate.roomTypeCode === roomData.roomTypeCode &&
						rate.ratePlanCode === rateKey
					) {
						// Retrieve matched ratePlan data
						const applicablePlanData = availRatePlans.filter(function(plan){
							return plan.ratePlanCode === rateKey
						})

						if (applicablePlanData[0]) {
							let specialPackageTitle = null
							let specialPackageDescription = null
							let specialPackageRateCode = null
							let specialPackageRate = null
							let currencyCode = 'USD'
							let currencySymbol = getCurrencySymbol(currencyCode)
							let renderSpecialPackageImage = ''
							let renderSpecialPackageButton = null

							if (applicablePlanData[0].ratePlanName) {
								specialPackageTitle = applicablePlanData[0].ratePlanName
							}

							if (applicablePlanData[0].ratePlanDescription &&
								applicablePlanData[0].ratePlanDescription.text
							) {
								specialPackageDescription = applicablePlanData[0].ratePlanDescription.text
							}

							if (applicablePlanData[0].ratePlanCode) {
								specialPackageRateCode = applicablePlanData[0].ratePlanCode
							}

							if (
								rate &&
								rate.rates &&
								_.get(rate.rates, '[0].total')
							) {
								if (
									rate.rates[0].total.amountBeforeTax &&
									totalNights
								) {
									if (displayedPriceFrequency === 'per stay') {
										specialPackageRate = rate.rates[0].total.amountBeforeTax
									} else {
										specialPackageRate = rate.rates[0].total.amountBeforeTax / totalNights
									}
								}

								if (rate.rates[0].total.currencyCode) {
									currencyCode = rate.rates[0].total.currencyCode
									currencySymbol = getCurrencySymbol(currencyCode)
								}
							}

							if (
								yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
								activeCurrencyData &&
								activeCurrencyData.exchangeRate &&
								activeCurrencyData.currencyCode
							) {
								if (displayedPriceFrequency === 'per stay') {
									specialPackageRate = rate.rates[0].total.amountBeforeTax * activeCurrencyData.exchangeRate
								} else {
									specialPackageRate = rate.rates[0].total.amountBeforeTax / totalNights * activeCurrencyData.exchangeRate
								}

								currencyCode = activeCurrencyData.currencyCode

								if (activeCurrencyData.currencySymbol) {
									currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
								} else {
									currencySymbol = getCurrencySymbol(currencyCode)
								}
							}

							// Init image or placeholder
							if (
								applicablePlanData[0].ratePlanDescription &&
								applicablePlanData[0].ratePlanDescription.image
							) {
								renderSpecialPackageImage = applicablePlanData[0].ratePlanDescription.image
							} else {
								renderSpecialPackageImage = placeholderImage
							}

							// Render button if specialPackageRateCode set
							if ( specialPackageRateCode ) {

								// toggleActiveRoom function (setActiveRoom, setActiveStep) inherited from parent BkFlowRoomCard
								renderSpecialPackageButton = (
									<button
										className="btn btn-transparent"
										onClick={ () => toggleActiveRoom(
											availabilityData,
											roomData.roomTypeCode,
											specialPackageRateCode,
											roomGroup,
											activeStep,
											multiRoomData,
											configData,
											urlData,
											enhancementData
										)
									}>
										{ hotelLabels.select } { hotelLabels.offer }
									</button>
								)
							}

							specialPackageEntries.push(
								<div
									className="bk-flow-special-packages__card"
									key={ roomData.code + '-' + applicablePlanData[0].ratePlanCode + '-' + roomGroup}
								>
									{ specialPackageTitle &&
										<div className="bk-flow-special-packages__card-title">
											<h5 className="u-remove-margin">
												{ specialPackageTitle }
											</h5>
										</div>
									}

									<div
										className="bk-flow-special-packages__card-image u-bg-image"
										style={ { backgroundImage: 'url(' +  renderSpecialPackageImage + ')' } }
									>
										<img
											className="u-element-hidden"
											src={ renderSpecialPackageImage }
											alt="Coming Soon"
										/>
									</div>

									<div className="bk-flow-special-packages__card-data">
										<div className="bk-flow-special-packages__card-copy">
											{ specialPackageDescription && renderHTML(specialPackageDescription) }
										</div>

										<div className="bk-flow-special-packages__card-submit">
											<p className="bk-flow-special-packages__card-price u-font-bold">
												{ currencySymbol }{ formatPrice(specialPackageRate) } { currencyCode }/{ displayedPriceFrequency === 'per stay' ? hotelLabels.total : hotelLabels.night }
											</p>
											{ renderSpecialPackageButton }
										</div>
									</div>
								</div>

							)
						}
					}
				})
			})

			return specialPackageEntries
		}

		const isSpecialPackagesComponentModal = process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES_COMPONENT === 'modal'
		const SpecialPackagesWrapper = isSpecialPackagesComponentModal
			? ModalWrapper
			: CollapseWrapper
		
		const specialPackagesId = `bk-special-packages-${roomTypeCode}`
		const specialPackagesClassName = isSpecialPackagesComponentModal
			? `bk-flow-special-packages bk-flow-special-packages-modal ${baseClassNames}`
			: `bk-flow-special-packages ${baseClassNames}`

		return  (
			<div id={specialPackagesId} className={specialPackagesClassName}>
				<SpecialPackagesWrapper
					isExpanded={specialPackagesExpanded}
					onRequestClose={toggleSpecialPackages}
					parentElementId={specialPackagesId}
				>
					<div className="bk-flow-special-packages__content">
						<p className="bk-flow-special-packages__title u-txt-center">
							{ hotelLabels.specialPackagesHeading ?
								hotelLabels.specialPackagesHeading
							:
								'Begin your reservation process by selecting one of the great offers below'
							}
						</p>
						<div className="bk-flow-special-packages__cards">
							{ renderSpecialPackageCards() }
						</div>
					</div>
				</SpecialPackagesWrapper>
			</div>
		)
	}


	render() {
		return (
			this.renderSpecialPackagesAccordion()
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
		multiRoomData: state.multiRoomData,
		availabilityData: state.availabilityData.availability,
		activeCurrencyData: state.activeCurrencyData,
		enhancementData: state.enhancementData,
		activeStep: state.activeStepData.activeStep
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomSpecialPackages)


// WEBPACK FOOTER //
// ./src/components/room/BkFlowRoomSpecialPackages.js